import { atom } from "recoil";

export const achievementStore = atom({
	key: "achievementStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
		statusCounts: {
			active: 0,
			disabled: 0,
		},
	},
});
